<div class="title">
	Signature
</div>
<signature-pad #signature [options]="signaturePadOptions" (drawStart)="drawStart($event)" (drawEnd)="drawComplete($event)"></signature-pad>
<div class="text-center mt-1">
	<button class="btn btn-secondary" (click)="clear()">Clear</button>
</div>